// SPDX-License-Identifier: AGPL-3.0-or-later

import type {User} from '@app/features/user/models/User';

// Keep the legacy signature for internal callers, but avatar-derived metadata
// no longer colors an entire camera/screen-share placeholder.
export const getPlaceholderAvatarColor = (_user: User | null | undefined, _fallback: string): string =>
	'var(--voice-placeholder-background, #1b1a19)';
